import TuneIcon from '@mui/icons-material/Tune';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { pxToRem } from 'src/common/utils/fonts';

type FiltersButtonProps = {
  active: boolean;
  onClick: () => void;
};

export const FiltersButton = ({ active, onClick }: FiltersButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      startIcon={<TuneIcon sx={{ width: pxToRem(16), height: pxToRem(16) }} />}
      onClick={onClick}
      sx={{
        minWidth: pxToRem(92),
      }}
      color={active ? 'active' : 'secondary'}
    >
      {t('common.filters')}
    </Button>
  );
};
